export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) {
    return '—';
  }
  if (seconds < 60) {
    return `${seconds}s`;
  }
  if (seconds < 3600) {
    return `${Math.round(seconds / 60)}m`;
  }
  return `${(seconds / 3600).toFixed(1)}h`;
}

export function formatMediaRef(mediaId: string, assetVersion: number): string {
  return `${mediaId} v${assetVersion}`;
}

export async function copyText(value: string) {
  await navigator.clipboard.writeText(value);
}

export function formatPeakAt(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  return date.toLocaleString(undefined, {
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCollectedAt(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  return new Date(iso).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}
